import { asyncThunkWrapper } from "../handleAsyncThunk"
import { BASEURI, headers } from "../../utils/helper"
import { createAsyncThunk } from "@reduxjs/toolkit"

// Handle retrieve all FAQs
export const retrieveAllFaqs = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        url: `${BASEURI}/public/faq/retrieve-all`,
      },
      thunkAPI,
      { showToast: false }
    )
  }
)

// Handle create FAQs
export const createFaqs = createAsyncThunk(
  "create",
  async (data, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "POST",
        url: `${BASEURI}/admin/faq/create`,
        data,
        headers: headers()
      },
      thunkAPI,
    )
)

// Handle delete FAQs
export const deleteFaqs = createAsyncThunk(
  "delete",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "DELETE",
        url: `${BASEURI}/admin/faq/delete/${id}`,
        headers: headers()
      },
      thunkAPI,
      {
        successMsg: "FAQ deleted successfully!"
      }
    )
)

// Handle retrieve single FAQs
export const retrieveFaqs = createAsyncThunk(
  "retrieveSingle",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/admin/faq/retrieve/${id}`,
      },
      thunkAPI,
      { showToast: false }
    )
)

// Handle update FAQs
export const updateFaqs = createAsyncThunk(
  "update",
  async (data, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "POST",
        url: `${BASEURI}/admin/faq/update/${data?.faqId}`,
        data: data?.formData,
        headers: headers()
      },
      thunkAPI,
      {
        successMsg: "FAQ updated!"
      }
    )
)